$(document).ready(function() {
    function jwHomepageInitReadMore() {
        // Check if the class exists on the page first
        var $containers = $('.jw_home_img_with_text_content');
        if ($containers.length === 0) return;
        
        var isMobile = $(window).width() <= 768;
        
        $containers.each(function() {
            var $container = $(this);
            var $paragraphs = $container.find('p');
            
            if ($paragraphs.length > 1) {
                $container.find('.jw-read-more-btn, .jw-read-more-wrapper').remove();
                $paragraphs.removeClass('jw-content-hidden');
                
                if (isMobile) {
                    var $firstPara = $paragraphs.first();
                    var $otherParas = $paragraphs.not($firstPara);
                    
                    $otherParas.wrapAll('<div class="jw-read-more-wrapper jw-content-hidden"></div>');
                    var $wrapper = $container.find('.jw-read-more-wrapper');
                    
                    var $readMoreBtn = $('<a class="jw-read-more-btn">+ Read more</a>');
                    $firstPara.after($readMoreBtn);
                    
                    $readMoreBtn.on('click', function(e) {
                        e.preventDefault();
                        var $btn = $(this);
                        
                        if ($wrapper.hasClass('jw-content-hidden')) {
                            // Expanding - move button to end
                            $wrapper.removeClass('jw-content-hidden').slideDown(300, function() {
                                $btn.detach().appendTo($wrapper);
                            });
                            $btn.text('− Read less');
                        } else {
                            // Collapsing - move button back
                            $wrapper.addClass('jw-content-hidden').slideUp(300, function() {
                                $btn.detach().insertAfter($firstPara);
                            });
                            $btn.text('+ Read more');
                        }
                    });
                }
            }
        });
    }
    
    jwHomepageInitReadMore();
    
    var jwHomepageResizeTimer;
    $(window).on('resize', function() {
        clearTimeout(jwHomepageResizeTimer);
        jwHomepageResizeTimer = setTimeout(jwHomepageInitReadMore, 250);
    });
});